import React from 'react';
import type { BlogPost } from '../../types';
import { useTranslation } from 'react-i18next';

interface HowToCiteProps {
  post: BlogPost;
  canonicalUrl: string;
}

const HowToCite: React.FC<HowToCiteProps> = ({ post, canonicalUrl }) => {
  const { t } = useTranslation('common');
  return (
    <div className="mt-16 p-6 rounded-2xl border border-white/10 bg-white/5 glass-effect">
      <h3 className="text-xl font-bold font-serif mb-3">{t('blogPostPage.howToCite')}</h3>
      <p suppressHydrationWarning className="text-sm text-white/80 italic">
        {`"${post.title}," The Action Firm, accessed ${new Date().toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })}, ${canonicalUrl}.`}
      </p>
    </div>
  );
};

export default HowToCite;